export const GTM_LINKED_TRUE_VALUE = 'true';
export const GTM_LINKED_FALSE_VALUE = 'false';
export const GA4_LINKED_TRUE_VALUE = 'true';
export const GA4_LINKED_FALSE_VALUE = 'false';
export const GA4_TOKEN_AUTHORIZED = 'authorized';
export const GA4_TOKEN_NON_AUTHORIZED = 'non-authorized';
